<template>
    <Loading />
    <RouterView v-slot="{ Component }">
        <transition
            name="fade"
            mode="out-in"
        >
            <component :is="Component" />
        </transition>
    </RouterView>

    <ModalFeature
        v-if="showModalFeature"
        :visible="showModalFeature"
        @closed="showModalFeature = false"
    />
</template>

<script>
import { mapGetters } from 'vuex';
import { PROFILE_TYPES, USER_CODE_STATUS } from '@/utils/enums';
import { usePostHogProvider } from '@/composables/usePostHog';

import Loading from '@/components/Loading';
import ModalFeature from './components/developer/ModalFeature.vue';

export default {
    name: 'App',

    components: {
        Loading,
        ModalFeature,
    },

    head: {
        title: 'Login',
        titleTemplate: '%s · Yampi Parceiros',
    },

    computed: {
        intercomChatIsEnabled() {
            return !!this.userRef && this.userPasswordChanged;
        },

        authUser() {
            return this.$store.getters['auth/user'];
        },

        hasDevProfile() {
            return this.userRolesStatus.find((u) => u.profile === PROFILE_TYPES.DEVELOPER).value === USER_CODE_STATUS.ACTIVE;
        },

        showModalFeature() {
            return this.authUser && this.hasDevProfile && this.$store.state.featureModal.show;
        },

        ...mapGetters('auth', ['$auth_intercom_signature', 'userPasswordChanged', 'isAuthenticated']),

        ...mapGetters('profile', ['userRoleType', 'userRef', 'userRolesStatus']),
    },

    beforeCreate() {
        this.$store.dispatch('global_loading/changeLoadingStatus', true);
    },

    mounted() {
        this.$store.dispatch('global_loading/changeLoadingStatus', false);
    },

    watch: {
        isAuthenticated(newVal) {
            if (newVal) {
                this.$store.dispatch('featureModal/checkAndShowModal');
            }
        },
    },

    setup() {
        usePostHogProvider();
    },
};
</script>
